import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';

import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import {
  PublicationStatus,
  RoleAction,
  RolePermissionSubject,
  Shift,
  ShiftState,
} from '@wilson/interfaces';
import { canShiftBeTimeAdjusted } from './can-shift-be-time-adjusted.fn';
import { ShiftsService } from '@wilson/shifts';
import { firstValueFrom } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthorizationModule } from '@wilson/authorization';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { AbilityServiceSignal } from '@casl/angular';

@Component({
  selector: 'wilson-fill-with-planned-time-action',
  imports: [
    NzDropdownModule,
    TranslatePipe,
    AuthorizationModule,
    NzTooltipModule,
  ],
  templateUrl: './fill-with-planned-time-action.component.html',
  styleUrl: './fill-with-planned-time-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FillWithPlannedTimeActionComponent {
  private readonly translate = inject(TranslateService);
  private shiftsService = inject(ShiftsService);
  private nzMessage = inject(NzMessageService);

  protected shiftId = '';
  protected canShiftBeTimeAdjusted = false;
  protected PublicationStatus = PublicationStatus;

  protected RoleAction = RoleAction;
  protected RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;
  @Input({
    required: true,
  })
  set shift(value: Shift | undefined) {
    if (value) {
      this.shiftId = value.id as string;
      this.canShiftBeTimeAdjusted = canShiftBeTimeAdjusted({
        shiftState: value.state,
        assignedUserId: value.userId as string,
        shiftPublicationStatus: value.publicationStatus,
      });
    }
  }

  @Output()
  saveSuccessful = new EventEmitter();

  ShiftState = ShiftState;

  async fillShiftWithPlannedTime(isDisabled: boolean): Promise<void> {
    if (!isDisabled) {
      try {
        await firstValueFrom(
          this.shiftsService.patchBulkSubmitShifts([this.shiftId]),
        );
        this.nzMessage.success(this.translate.instant('popup.save.text'));
        this.saveSuccessful.emit();
      } catch {
        this.nzMessage.error(
          this.translate.instant('general.something_went_wrong'),
        );
      }
    }
  }
}
